<ng-content></ng-content>
@if (!this.dialog.disableClose && !this.hideCloseBtn()) {
  <button class="close-btn" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
}
